/** @jsx jsx */
import React from 'react';

import { jsx } from '@emotion/core';
import { useMarkdownMultilineTranslate } from 'hooks/useTranslate/useTranslate';
import SimpleMessagePage from 'components/SimpleMessagePage';

const AcceptanceErrorView: React.FC = () => {
  const tMdMultiline = useMarkdownMultilineTranslate();

  return (
    <SimpleMessagePage
      headerTitle="magicLink.magicLinkAcceptance.error.title"
      message={tMdMultiline('magicLink.magicLinkAcceptance.error.message')}
    />
  );
};

export default AcceptanceErrorView;
